export default function SectionHeader({ eyebrow, title, description, align = "left", testid }) {
  return (
    <div
      data-testid={testid}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {eyebrow && <div className="rk-eyebrow">{eyebrow}</div>}
      <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base leading-relaxed text-[#475569]">
          {description}
        </p>
      )}
    </div>
  );
}
